import Dictionary from "../../../models/Dictionary";

type ProductSide = TestRequestRaw.Schemas.ProductSide;

export const PRODUCT_SIDES: ProductSide[] = ["OPEN", "CLOSED", "SYMMETRICAL", "UNKNOWN"];

export const PRODUCT_SIDE_DICTIONARY: Dictionary<ProductSide, string> = {
  OPEN: "Open",
  CLOSED: "Closed",
  SYMMETRICAL: "Symmetrical",
  UNKNOWN: "Unknown",
};

export default ProductSide;
